module.exports = __webpack_public_path__ + "static/media/25.76ebdf7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/25.jpg
// module id = 965
// module chunks = 0